<template>
  <div class="secundaryTemplate">
    <div class="card-title margin-card">
      <nav aria-label="breadcrumbs mt-1">
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/map">Mapa</router-link>
          </li>
          <slot name="breadcrumb"></slot>
        </ul>
      </nav>
    </div>
    <div class="card-content px-3">
      <Overlay :show="this.$store.getters.isLoading">
        <div v-if="showRequired" class="alert alert-danger d-flex align-items-center mb-3" role="alert">
          <i class="fa fa-exclamation-circle mr-2" style="color: #fff;" aria-hidden="true"></i>
          <div>Campos em vermelho são obrigatórios.</div>
        </div>
        <slot name="body"></slot>
      </Overlay>
    </div>
  </div>
</template>

<script>
import Overlay from '@/components/extra/Overlay.vue';


export default {
  name: "TemplateCrud",
  props: ["showRequired"],
  components: {
    Overlay,
  },
  // no local components required
}
</script>

<style>
/* .nav-tabs{
  justify-content: center;
} */
</style>
